import { styled } from '@mui/system';
import { Button, List, ListItem } from '@mui/material';
import COLORS from '../../../../../theme/Colors';
import { boxShadowConfig } from '../../../../../theme/Styles';
import FONTS_FAMILY from '../../../../../theme/FontsFamily';
import CottageIcon from '@mui/icons-material/Cottage';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HandymanIcon from '@mui/icons-material/Handyman';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLORS.white,
    textAlign: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: '220px',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.04)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    padding: '16px',
    border: `1px solid ${COLORS.lightGray}`,
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
    }
});

export const CenterContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
});

export const Title = styled('h3')({
    margin: '0 0 8px 0',
    fontFamily: FONTS_FAMILY.bold.body,
    textAlign: 'left',
    width: '100%',
    fontSize: '16px',
    lineHeight: '1.3',
    color: COLORS.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    '-webkit-box-orient': 'vertical',
});

export const Separator = styled('div')({
    width: '80%',
    height: '1px',
    backgroundColor: COLORS.secondary,
});

export const BodyText = styled('p')({
    fontFamily: FONTS_FAMILY.regular.body,
    textAlign: 'left',
    fontSize: '13px',
    lineHeight: '1.5',
    color: 'rgba(32, 42, 93, 0.8)',
    marginTop: '0',
    marginBottom: '14px',
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    '-webkit-box-orient': 'vertical',
});

export const FirstIcon = styled(CottageIcon)({
    alignSelf: 'flex-end',
    marginRight: '20px',
    color: COLORS.secondary,
    '@media (min-width:320px)': {
        fontSize: '70px',
    },
    '@media (min-width:768px)': {
        fontSize: '70px',
    },
    '@media (min-width:1200px)': {
        fontSize: '70px',
    }
});

export const SecondIcon = styled(HandymanIcon)({
    alignSelf: 'flex-end',
    marginRight: '20px',
    color: COLORS.secondary,
    '@media (min-width:320px)': {
        fontSize: '70px',
    },
    '@media (min-width:768px)': {
        fontSize: '70px',
    },
    '@media (min-width:1200px)': {
        fontSize: '70px',
    }
});

export const ThirdIcon = styled(HomeWorkIcon)({
    alignSelf: 'flex-end',
    marginRight: '20px',
    color: COLORS.secondary,
    '@media (min-width:320px)': {
        fontSize: '70px',
    },
    '@media (min-width:768px)': {
        fontSize: '70px',
    },
    '@media (min-width:1200px)': {
        fontSize: '70px',
    }
});

export const LinkText = styled('div')({
    color: COLORS.primary,
    width: '100%',
    padding: '6px 0',
    textDecoration: 'none',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: FONTS_FAMILY.medium.title,
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
        color: COLORS.secondary,
        '& svg': {
            transform: 'translateX(4px)',
        }
    },
    '& svg': {
        fontSize: '12px',
        transition: 'transform 0.2s ease',
    }
});

export const CardIconContainer = styled("div")({
    display: 'flex',
    alignSelf: 'center',
    width: '60px',
    height: '60px',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    '& img': {
        width: '60px',
        height: '60px',
        objectFit: 'contain',
    }
});